

// Разделитель иконок (не требуется)
import { FC } from 'react';

export const IndicatorSeparator: FC<any> = () => {
    return <div></div>;
};


// Разделитель иконок (не требуется)
import { FC } from 'react';

export const IndicatorSeparator: FC<any> = () => {
    return <div></div>;
};
